import styled from 'styled-components';

export const FormButtonWrapper = styled.div<{ $disabled?: boolean }>`
	pointer-events: ${props => (props.$disabled ? 'none' : 'auto')}!important;
	opacity: ${props => (props.$disabled ? 0.5 : 1)};
	width: 100%;
	margin: auto;
`;
